const Main  = () => import ('../views/main/main.vue')
const fcIndex = () => import ('@/views/basic/fcIndex')
const letIndex = () => import ('@/views/basic/letIndex')
const lebcIndex = () => import ('@/views/basic/lebcIndex')
const lebcForm = () => import ('@/views/basic/lebcForm')
const lcIndex = () => import ('@/views/basic/lcIndex')
const cvIndex = () => import ('@/views/basic/cvIndex')
const cvForm = () => import ('@/views/basic/cvForm')
export default [{
  path: '/basic',
  component: Main,
  redirect: '',
  meta: {
    title: '基础资料',
    icon: 'guide'
  },
  children: [
    {
      path: 'fcIndex',
      component: fcIndex,
      name: 'fcIndex',
      meta: { title: '财务月份', keepAlive: true }
    },
    {
      path: 'letIndex',
      component: letIndex,
      name: 'letIndex',
      meta: { title: '商品分类', keepAlive: true }
    },
    {
      path: 'lebcIndex',
      component: lebcIndex,
      name: 'lebcIndex',
      meta: { title: '商品资料', keepAlive: true }
    },
    {
      path: 'lebcForm',
      component: lebcForm,
      name: 'lebcForm',
      meta: { title: '商品维护', keepAlive: true }
    },
    {
      path: 'lcIndex',
      component: lcIndex,
      name: 'lcIndex',
      meta: { title: '仓库资料', keepAlive: true }
    },
    {
      path: 'cvIndex',
      component: cvIndex,
      name: 'cvIndex',
      meta: { title: '往来单位', keepAlive: true }
    },
    {
      path: 'cvForm',
      component: cvForm,
      name: 'cvForm',
      meta: { title: '单位信息维护', keepAlive: true }
    },
  ]
}]
